<template>
  <div>
    <div class="row dvContent">
      <BodyLoader :loading="firstLoad"></BodyLoader>

      <div class="col s12 dvContentMain">
        <div class="dvSectionTitle "><span class="icon-fs_reports"></span>Reports</div>

        <div class="row">
          <div class="col s12 l8">
            <div class="dvReport-box isPrimary">
              <div class="dvReport-title"><span class="icon-fs_referrals"></span>Download Referrals</div>

              <div class="row">
                <div class="col s12 m6">
                  <div
                    ref="tippy_sort_menu"
                    name="sort-menu1"
                    class="waves-effect waves-light btn-Pill forReports">
                    <div class="label">Filter</div>
                    <div class="dividerVert"></div>
                    <span class="detail-dropdown">{{ referralsType }}</span>
                    <span class="icon-nav_chevron-down"></span>
                  </div> <!-- btn-Pill -->
                </div> <!-- col -->
                <div class="col s12 m6">
                  <div class="dvReport-range">
                    <v-menu
                      v-model="refStartDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px">
                      <template v-slot:activator="{ on }">
                        <div class="dvReport-range-select" v-on="on"><span class="icon-content_calendar"></span>{{ refStartDateLabel }}</div>
                      </template>
                      <v-date-picker
                      :max="new Date().toISOString().substr(0, 10)"
                      min="2020-03-01"
                      v-model="refStartDate" @input="refStartDateMenu = false" @change="saveRefStartDate"></v-date-picker>
                    </v-menu>

                    <v-menu
                      v-model="refEndDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px">
                      <template v-slot:activator="{ on }">
                        <div class="dvReport-range-select isSecondary" v-on="on"><span class="icon-content_calendar"></span>{{ refEndDateLabel }}</div>
                      </template>
                      <v-date-picker
                      :max="new Date().toISOString().substr(0, 10)"
                      :min="refStartDate"
                      v-model="refEndDate" @input="refEndDateMenu = false" @change="saveRefEndDate"></v-date-picker>
                    </v-menu>
                  </div> <!-- dvReport-range -->


                </div> <!-- col -->
                <div class="col s12 m6">
                  <div class="dvReport-info">
                    Documents are in Excel (XLS) format and requires Microsoft Excel to view and print.
                  </div> <!-- dvReport-info -->
                </div> <!-- col -->
                <div class="col s12 m6">
                  <div class="row dvReport-actions">
                    <div class="col s12 m6">
                      <div @click="downloadReferral('download')" class="waves-effect waves-dark btn-RoundCorners"><div class="label">Download</div><span class="icon-nav_link_down"></span></div>
                    </div> <!-- col -->
                    <div class="col s12 m6">
                      <div @click="downloadReferral('mail')" class="waves-effect waves-dark btn-RoundCorners"><span class="icon-content_email"></span><div class="label">Send Email</div></div>
                    </div> <!-- col -->
                  </div> <!-- dvReport-actions -->
                </div>

              </div> <!-- row -->
            </div> <!-- dvReport-box -->

            <tippy
             to="sort-menu1"
             placement="bottom"
             offset="[0, 0]"
             interactive
             trigger="click"
             hideOnClick="true"
             theme="light-border"
             arrow="false">
             <div class="sortPopMenuBox-content ">
               <a
                @click="setReferralType('Valid')"
                href="javascript:void(0)" class="sortPopMenuBox-content-item">
                 Valid
               </a>
               <a
                @click="setReferralType('Pending')"
                href="javascript:void(0)" class="sortPopMenuBox-content-item">
                 Pending
               </a>
               <a
                @click="setReferralType('Expiring')"
                href="javascript:void(0)" class="sortPopMenuBox-content-item">
                 Expiring
               </a>
               <a
                @click="setReferralType('Archived')"
                href="javascript:void(0)" class="sortPopMenuBox-content-item">
                 Archived
               </a>
               <a
                @click="setReferralType('All')"
                href="javascript:void(0)" class="sortPopMenuBox-content-item">
                 All
               </a>
             </div>
           </tippy>


          </div> <!-- col -->

          <div class="col s12 l4">
            <div class="dvReport-box">
              <div class="dvReport-title"><span class="icon-content_activity"></span>Activity Logs</div>

              <div class="dvReport-range">
                <v-menu
                  v-model="activityLogsStartDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px">
                  <template v-slot:activator="{ on }">
                    <div class="dvReport-range-select" v-on="on"><span class="icon-content_calendar"></span>{{ activityLogsStartDateLabel }}</div>
                  </template>
                  <v-date-picker
                  :max="new Date().toISOString().substr(0, 10)"
                  min="2020-03-01"
                  v-model="activityLogsStartDate" @input="activityLogsStartDateMenu = false" @change="saveActivityLogsStartDate"></v-date-picker>
                </v-menu>

                <v-menu
                  v-model="activityLogsEndDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px">
                  <template v-slot:activator="{ on }">
                    <div class="dvReport-range-select isSecondary" v-on="on"><span class="icon-content_calendar"></span>{{ activityLogsEndDateLabel }}</div>
                  </template>
                  <v-date-picker
                  :max="new Date().toISOString().substr(0, 10)"
                  :min="activityLogsStartDate"
                  v-model="activityLogsEndDate" @input="activityLogsEndDateMenu = false" @change="saveActivityLogsEndDate"></v-date-picker>
                </v-menu>
              </div> <!-- dvReport-range -->



              <div class="row dvReport-actions">
                <div class="col s12 m6">
                  <div @click="downAtcitivityLogs('download')" class="waves-effect waves-dark btn-RoundCorners"><div class="label">Download</div><span class="icon-nav_link_down"></span></div>
                </div> <!-- col -->
                <div class="col s12 m6">
                  <div @click="downAtcitivityLogs('mail')" class="waves-effect waves-dark btn-RoundCorners"><span class="icon-content_email"></span><div class="label">Send Email</div></div>
                </div> <!-- col -->
              </div> <!-- dvReport-actions -->

            </div> <!-- dvReport-box -->
          </div> <!-- dvReport -->

          <div class="col s12 l4" v-if="$getConstRole('ROLE_SUB_ADMIN') != $store.getters.getCurrentUserRole">
            <div class="dvReport-box">
              <div class="dvReport-title"><span class="icon-content_trending_up"></span>Team Stats</div>

              <div class="dvReport-range">
                <v-menu
                  v-model="teamStatsStartDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px">
                  <template v-slot:activator="{ on }">
                    <div class="dvReport-range-select" v-on="on"><span class="icon-content_calendar"></span>{{ teamStatsStartDateLabel }}</div>
                  </template>
                  <v-date-picker
                  :max="new Date().toISOString().substr(0, 10)"
                  min="2020-03-01"
                  v-model="teamStatsStartDate" @input="teamStatsStartDateMenu = false" @change="saveTeamStatsStartDate"></v-date-picker>
                </v-menu>

                <v-menu
                  v-model="teamStatsEndDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px">
                  <template v-slot:activator="{ on }">
                    <div class="dvReport-range-select isSecondary" v-on="on"><span class="icon-content_calendar"></span>{{ teamStatsEndDateLabel }}</div>
                  </template>
                  <v-date-picker
                  :max="new Date().toISOString().substr(0, 10)"
                  :min="teamStatsStartDate"
                  v-model="teamStatsEndDate" @input="teamStatsEndDateMenu = false" @change="saveTeamStatsEndDate"></v-date-picker>
                </v-menu>
              </div> <!-- dvReport-range -->

              <div class="row dvReport-actions">
                <div class="col s12 m6">
                  <div @click="downloadTeamStats('download')" class="waves-effect waves-dark btn-RoundCorners"><div class="label">Download</div><span class="icon-nav_link_down"></span></div>
                </div> <!-- col -->
                <div class="col s12 m6">
                  <div @click="downloadTeamStats('mail')" class="waves-effect waves-dark btn-RoundCorners"><span class="icon-content_email"></span><div class="label">Send Email</div></div>
                </div> <!-- col -->
              </div> <!-- dvReport-actions -->

            </div> <!-- dvReport-box -->
          </div> <!-- dvReport -->

          <div class="col s12 l4" v-if="$getConstRole('ROLE_MANAGER') == $store.getters.getCurrentUserRole">
            <div class="dvReport-box">
              <div class="dvReport-title"><span class="icon-editor_list"></span>Team Activity</div>

              <div class="dvReport-range">
                <v-menu
                  v-model="teamActivityStartDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px">
                  <template v-slot:activator="{ on }">
                    <div class="dvReport-range-select" v-on="on"><span class="icon-content_calendar"></span>{{ teamActivityStartDateLabel }}</div>
                  </template>
                  <v-date-picker
                  :max="new Date().toISOString().substr(0, 10)"
                  min="2020-03-01"
                  v-model="teamActivityStartDate" @input="teamActivityStartDateMenu = false" @change="saveTeamActivityStartDate"></v-date-picker>
                </v-menu>

                <v-menu
                  v-model="teamActivityEndDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px">
                  <template v-slot:activator="{ on }">
                    <div class="dvReport-range-select isSecondary" v-on="on"><span class="icon-content_calendar"></span>{{ teamActivityEndDateLabel }}</div>
                  </template>
                  <v-date-picker
                  :max="new Date().toISOString().substr(0, 10)"
                  :min="teamActivityStartDate"
                  v-model="teamActivityEndDate" @input="teamActivityEndDateMenu = false" @change="saveTeamActivityEndDate"></v-date-picker>
                </v-menu>
              </div> <!-- dvReport-range -->

              <div class="row dvReport-actions">
                <div class="col s12 m6">
                  <div @click="downloadTeamActivity('download')" class="waves-effect waves-dark btn-RoundCorners"><div class="label">Download</div><span class="icon-nav_link_down"></span></div>
                </div> <!-- col -->
                <div class="col s12 m6">
                  <div @click="downloadTeamActivity('mail')" class="waves-effect waves-dark btn-RoundCorners"><span class="icon-content_email"></span><div class="label">Send Email</div></div>
                </div> <!-- col -->
              </div> <!-- dvReport-actions -->

            </div> <!-- dvReport-box -->
          </div> <!-- dvReport -->

          <div class="col s12 l4" v-if="$getConstRole('ROLE_SUB_ADMIN') != $store.getters.getCurrentUserRole">
            <div class="dvReport-box">
              <div class="dvReport-title"><span class="icon-fs_world"></span>Global Stats</div>

              <div class="dvReport-range">
                <v-menu
                  v-model="globalStatStartDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px">
                  <template v-slot:activator="{ on }">
                    <div class="dvReport-range-select" v-on="on"><span class="icon-content_calendar"></span>{{ globalStatStartDateLabel }}</div>
                  </template>
                  <v-date-picker
                  :max="new Date().toISOString().substr(0, 10)"
                  min="2020-03-01"
                  v-model="globalStatStartDate" @input="globalStatStartDateMenu = false" @change="saveGlobalStatStartDate"></v-date-picker>
                </v-menu>

                <v-menu
                  v-model="globalStatEndDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px">
                  <template v-slot:activator="{ on }">
                    <div class="dvReport-range-select isSecondary" v-on="on"><span class="icon-content_calendar"></span>{{ globalStatEndDateLabel }}</div>
                  </template>
                  <v-date-picker
                  :max="new Date().toISOString().substr(0, 10)"
                  :min="globalStatStartDate"
                  v-model="globalStatEndDate" @input="globalStatEndDateMenu = false" @change="saveGlobalStatEndDate"></v-date-picker>
                </v-menu>
              </div> <!-- dvReport-range -->

              <div class="row dvReport-actions">
                <div class="col s12 m6">
                  <div @click="downloadGlobalStats('download')" class="waves-effect waves-dark btn-RoundCorners"><div class="label">Download</div><span class="icon-nav_link_down"></span></div>
                </div> <!-- col -->
                <div class="col s12 m6">
                  <div @click="downloadGlobalStats('mail')" class="waves-effect waves-dark btn-RoundCorners"><span class="icon-content_email"></span><div class="label">Send Email</div></div>
                </div> <!-- col -->
              </div> <!-- dvReport-actions -->

            </div> <!-- dvReport-box -->
          </div> <!-- dvReport -->


        </div> <!-- row -->
      </div> <!-- dvContentMain -->

      <div class="col s12 dvContentTools noContent">
        <div class="dvContentTools-fx"></div>
        <div class="dvContentTools-page">
          <a disabled href="#" class="waves-effect waves-dark btn btn-Tools isSecondary flexCenterAll"><span class="icon-content_email"></span><div class="hide-on-small-only">Email</div></a>
          <a disabled href="#" class="waves-effect waves-dark btn btn-Tools isSecondary flexCenterAll"><span class="icon-action_print"></span><div class="hide-on-small-only">Print</div></a>
          <ToTop></ToTop>
        </div>

      </div>

    </div> <!-- dvContent -->
    <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
  </div>
</template>
<style>
.v-date-picker-table .v-btn.v-btn--active {
  color: #666!important;
}
.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: #005caf !important;
    color: #fff!important;
}
</style>

<script>
  import BodyLoader from '@/components/BodyLoader.vue'
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import ToTop from '@/components/totop/ToTop.vue'

  export default {
    name: 'reports-main',
    data: () => ({
      firstLoad: true,
      referralsType: 'Valid',
      refStartDateLabel: 'Start Date',
      refStartDate: new Date().toISOString().substr(0, 10),
      refEndDateLabel: 'End Date',
      refEndDate: new Date().toISOString().substr(0, 10),
      refStartDateMenu: false,
      refEndDateMenu: false,


      activityLogsStartDateLabel: 'Start Date',
      activityLogsStartDate: new Date().toISOString().substr(0, 10),
      activityLogsEndDateLabel: 'End Date',
      activityLogsEndDate: new Date().toISOString().substr(0, 10),
      activityLogsStartDateMenu: false,
      activityLogsEndDateMenu: false,

      teamStatsStartDateLabel: 'Start Date',
      teamStatsStartDate: new Date().toISOString().substr(0, 10),
      teamStatsEndDateLabel: 'End Date',
      teamStatsEndDate: new Date().toISOString().substr(0, 10),
      teamStatsStartDateMenu: false,
      teamStatsEndDateMenu: false,

      teamActivityStartDateLabel: 'Start Date',
      teamActivityStartDate: new Date().toISOString().substr(0, 10),
      teamActivityEndDateLabel: 'End Date',
      teamActivityEndDate: new Date().toISOString().substr(0, 10),
      teamActivityStartDateMenu: false,
      teamActivityEndDateMenu: false,

      globalStatStartDateLabel: 'Start Date',
      globalStatStartDate: new Date().toISOString().substr(0, 10),
      globalStatEndDateLabel: 'End Date',
      globalStatEndDate: new Date().toISOString().substr(0, 10),
      globalStatStartDateMenu: false,
      globalStatEndDateMenu: false,


      domain: '',
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
    }),
    watch: {
      refStartDate: function() {
        this.refStartDateLabel = this.refStartDate
      },
      refEndDate: function() {
        this.refEndDateLabel = this.refEndDate
      }
    },
    methods: {
      saveRefEndDate (date){
        this.refEndDateLabel = date
      },
      saveRefStartDate (date){
        this.refStartDateLabel = date
      },
      saveTeamStatsEndDate (date){
        this.teamStatsEndDateLabel = date
      },
      saveTeamStatsStartDate (date){
        this.teamStatsStartDateLabel = date
      },
      saveActivityLogsEndDate (date){
        this.activityLogsEndDateLabel = date
      },
      saveActivityLogsStartDate (date){
        this.activityLogsStartDateLabel = date
      },
      saveTeamActivityEndDate (date){
        this.teamActivityEndDateLabel = date
      },
      saveTeamActivityStartDate (date){
        this.teamActivityStartDateLabel = date
      },
      saveGlobalStatEndDate (date){
        this.globalStatEndDateLabel = date
      },
      saveGlobalStatStartDate (date){
        this.globalStatStartDateLabel = date
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      },
      downloadReferral (requestType) {
        let url = this.domain + '/api/reports/referrals?referral_type='+this.referralsType+'&request_type='+requestType

        if(this.refStartDateLabel != 'Start Date'){
          url+= '&start_date='+this.refStartDateLabel
        }

        if(this.refEndDateLabel != 'End Date'){
          url+= '&end_date='+this.refEndDateLabel
        }

        if(requestType == 'download'){
          window.location.href = url
          return
        }

        this.$http.plain.get(url)
          .then(response => {
            if(response.data == 'sent'){
              this.showMessage('Reports have been sent', 'sb-success')
            }
          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
      },
      downAtcitivityLogs (requestType) {
        let url = this.domain + '/api/reports/activity_logs?request_type='+requestType

        if(this.activityLogsStartDateLabel != 'Start Date'){
          url+= '&start_date='+this.activityLogsStartDateLabel
        }

        if(this.activityLogsEndDateLabel != 'End Date'){
          url+= '&end_date='+this.activityLogsEndDateLabel
        }

        if(requestType == 'download'){
          window.location.href = url
          return
        }


        this.$http.plain.get(url)
          .then(response => {
            if(response.data == 'sent'){
              this.showMessage('Reports have been sent', 'sb-success')
            }
          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
      },
      downloadTeamStats (requestType) {
        let url = this.domain + '/api/reports/team_stats?request_type='+requestType

        if(this.teamStatsStartDateLabel != 'Start Date'){
          url+= '&start_date='+this.teamStatsStartDateLabel
        }

        if(this.teamStatsEndDateLabel != 'End Date'){
          url+= '&end_date='+this.teamStatsEndDateLabel
        }

        if(requestType == 'download'){
          window.location.href = url
          return
        }

        this.$http.plain.get(url)
          .then(response => {
            if(response.data == 'sent'){
              this.showMessage('Reports have been sent', 'sb-success')
            }
          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
      },
      downloadTeamActivity (requestType) {
        let url = this.domain + '/api/reports/team_activity?request_type='+requestType

        if(this.teamActivityStartDateLabel != 'Start Date'){
          url+= '&start_date='+this.teamActivityStartDateLabel
        }

        if(this.teamActivityEndDateLabel != 'End Date'){
          url+= '&end_date='+this.teamActivityEndDateLabel
        }

        if(requestType == 'download'){
          window.location.href = url
          return
        }

        this.$http.plain.get(url)
          .then(response => {
            if(response.data == 'sent'){
              this.showMessage('Reports have been sent', 'sb-success')
            }
          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
      },
      downloadGlobalStats (requestType) {
        let url = this.domain + '/api/reports/global_stats?request_type='+requestType

        if(this.globalStatStartDateLabel != 'Start Date'){
          url+= '&start_date='+this.globalStatStartDateLabel
        }

        if(this.globalStatEndDateLabel != 'End Date'){
          url+= '&end_date='+this.globalStatEndDateLabel
        }

        if(requestType == 'download'){
          window.location.href = url
          return
        }

        this.$http.plain.get(url)
          .then(response => {
            if(response.data == 'sent'){
              this.showMessage('Reports have been sent', 'sb-success')
            }
          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
      },
      setReferralType (refType) {
        let el = this.$refs['tippy_sort_menu'];
                if (el && el._tippy) {
                    el._tippy.hide()
                }
        this.referralsType = refType
      }
    },
    mounted() {
      this.domain = this.$store.getters.getApiURL
      this.firstLoad = false
    },
    components: {
      BodyLoader,
      SnackBar,
      ToTop
    }
  }
</script>
